import { createGlobalStyle } from 'styled-components'

export const NOTIFICATION_CLASS_NAMES = {
  success: 'rankmi-lms-notification-success',
  info: 'rankmi-lms-notification-info',
  warning: 'rankmi-lms-notification-warning',
  error: 'rankmi-lms-notification-error',
} as const

const notificationBase = `
  padding: 8px 12px !important;
  border-radius: 8px !important;
  box-shadow: 0px 4px 16px 0px #0000003d !important;

  & > div > div > span {
    font-size: 14px;
  }

  & > div > div > div {
    color: #213f68;
    font-weight: 700;
    font-family: Roboto, sans-serif;
    margin-left: 28px !important;
    margin-bottom: 0 !important;
  }

  & .ant-notification-notice-description {
    color: #213f68;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    line-height: 24px;
    margin-left: 28px !important;
    margin-top: 0 !important;
  }

  & > a {
    top: 10px;
    right: 16px;
    color: #757575;
  }
`

export const NotificationGlobalStyles = createGlobalStyle`
  .${NOTIFICATION_CLASS_NAMES.success} {
    ${notificationBase}
    background-color: #d7f5e9 !important;
  }

  .${NOTIFICATION_CLASS_NAMES.success} > div > div > span {
    color: #00b47c;
  }

  .${NOTIFICATION_CLASS_NAMES.info} {
    ${notificationBase}
    background-color: #e7f3fe !important;
  }

  .${NOTIFICATION_CLASS_NAMES.info} > div > div > span {
    color: #2684ff;
  }

  .${NOTIFICATION_CLASS_NAMES.warning} {
    ${notificationBase}
    background-color: #fff2c7 !important;
  }

  .${NOTIFICATION_CLASS_NAMES.warning} > div > div > span {
    color: #faad14 !important;
  }

  .${NOTIFICATION_CLASS_NAMES.error} {
    ${notificationBase}
    background-color: #fde0e0 !important;
  }

  .${NOTIFICATION_CLASS_NAMES.error} > div > div > span {
    color: #ff5b55 !important;
  }
`
